import type { TrigKey } from './keys';

export const zh: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': '数学 · 三角',
  'panel.experiment': '实验',
  'panel.params': '参数',
  'panel.scene': '选择实验',
  'experiment.right-triangle.label': '直角三角形',
  'experiment.unit-circle.label': '单位圆',
  'experiment.wave-studio.label': '波形工作室',
  'experiment.identity-playground.label': '恒等式',
  'experiment.triangle-solver.label': '三角形解算',
  'experiment.circular-polar.label': '圆周与极坐标',
  'hint.line1': '拖动点,移动滑块。',
  'hint.line2': '教育内容存在于几何中,而非文字里。',
  'rt.angle.a': '角 A',
  'rt.angle.b': '角 B',
  'rt.angle.value': '∠',
  'rt.units.rad': '弧度',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '吸附到 30°/45°/60°',
  'uc.units': '单位',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': '显示 ASTC',
  'uc.snap.common': '吸附到常用角',
  'uc.angle.value': '∠',
  'uc.units.deg': '度',
  'uc.units.rad': '弧度',
  'uc.units.both': '度+弧度',
  'ws.fn': '函数',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — 振幅',
  'ws.frequency': 'B — 频率',
  'ws.phase': 'C — 相位偏移',
  'ws.shift': 'D — 垂直平移',
  'ws.rform.toggle': 'R-形式推导',
  'ws.rform.a': 'a (sin 系数)',
  'ws.rform.b': 'b (cos 系数)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': '重置',
  'ws.base': '显示基础曲线',
  'ip.id.pythagorean': '毕达哥拉斯',
  'ip.id.reciprocal': '倒数',
  'ip.id.quotient': '商',
  'ip.id.sum': '和',
  'ip.id.difference': '差',
  'ip.id.double': '二倍角',
  'ip.id.half': '半角',
  'ip.play': '播放',
  'ip.pause': '暂停',
  'ip.step': '步进',
  'ip.reset': '重置',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': '将在 v2 推出 — 此证明需要更详尽的构造。',
  'ts.area': '面积',
  'ts.sineRule': '正弦定理',
  'ts.cosineRule': '余弦定理',
  'ts.ambiguous.toggle': '歧义时显示幽灵三角',
  'ts.reset': '重置为等边',
  'ts.snap.integers': '吸附到整数',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': '边',
  'ts.section.angles': '角',
  'ts.section.sineRule': '正弦定理',
  'ts.section.cosineRule': '余弦定理',
  'ts.section.area': '面积',
  'cp.omega': '角速度',
  'cp.plot.y': '绘制 y (sin)',
  'cp.plot.x': '绘制 x (cos)',
  'cp.polar.label': '极坐标图',
  'cp.polar.circle': '圆 (r = 1)',
  'cp.polar.rose': '玫瑰线 (r = sin 3θ)',
  'cp.polar.cardioid': '心形线 (r = 1 + cos θ)',
  'cp.polar.limacon': '蚶线 (r = 1 − 2 cos θ)',
  'cp.smallAngle': '小角近似 (sin x ≈ x)',
  'cp.play': '播放',
  'cp.pause': '暂停',
  'cp.reset': '重置',
  'cp.step': '步进 π/12',
};
